import React from 'react'

import MapaCoordenadaFormPageContainer from './MapaCoordenadaFormPageContainer'

export class MapaCoordenadaFormPage extends React.Component {
  render() {
    return <MapaCoordenadaFormPageContainer {...this.props} />
  }
}
